import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/modules/auth'
import { isRestorablePath } from '@/shared/utils/auth'
import { FullPageSkeleton } from '@/ui/components'
import LandingPage from '@/pages/LandingPage'

/**
 * Conditional route component for the home page (/)
 * - admin.sitrepp.io at /: Redirect to /admin
 * - Beta users (authenticated + is_beta_user = true): Show LandingPage
 * - Non-beta authenticated users: Redirect to dashboard
 * - Unauthenticated users: Show LandingPage (marketing)
 */
export default function ConditionalLandingRoute() {
  const location = useLocation()
  const { user, isAuthenticated, isBetaUser, isLoading } = useAuth()

  if (typeof window !== 'undefined' && window.location.hostname === 'admin.sitrepp.io' && location.pathname === '/') {
    return <Navigate to="/admin" replace />
  }

  // Show loading spinner while auth is initializing
  if (isLoading) {
    return <FullPageSkeleton />
  }

  // Beta users see the normal landing page
  if (isAuthenticated && isBetaUser) {
    return <LandingPage />
  }

  // Non-beta authenticated users redirect to dashboard
  if (isAuthenticated && !isBetaUser) {
    try {
      const last = sessionStorage.getItem('last_pathname')
      if (isRestorablePath(last)) {
        return <Navigate to={last} replace />
      }
    } catch {}
    return <Navigate to="/dashboard" replace />
  }

  return <LandingPage />
}

